export default __webpack_public_path__ + "static/media/13_jethro_loben.1aefddae.jpg";